import type { TimeSlot } from './TimeSlot';
import type { ShiftSlotStatus } from './ShiftSlotStatus';
import * as holidayJp from '@holiday-jp/holiday_jp';

/**
 * 日次シフト枠ビジネスポリシー
 */
export const DailyShiftSlotPolicy = {
  /**
   * 編集可能かどうか判定
   */
  isEditable(status: ShiftSlotStatus): boolean {
    return status !== 'confirmed';
  },

  /**
   * 不足枠を計算
   */
  calculateShortageSlots(recruitmentSlots: number, confirmedSlots: number): number {
    return Math.max(0, recruitmentSlots - confirmedSlots);
  },

  /**
   * 応募可能かどうか判定
   */
  canApply(slot: TimeSlot): boolean {
    return slot.confirmedSlots < slot.recruitmentSlots;
  },

  /**
   * 日付が祝日かどうか判定
   * @holiday-jp/holiday_jp ライブラリ使用
   */
  isJapaneseHoliday(date: Date): boolean {
    return holidayJp.isHoliday(date);
  },

  /**
   * 祝日名を取得
   */
  getHolidayName(date: Date): string | undefined {
    // betweenメソッドで該当日の祝日を取得
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    const holidays = holidayJp.between(date, endOfDay);
    if (holidays.length > 0) {
      return holidays[0].name;
    }
    return undefined;
  },

  /**
   * 曜日を取得（0=日曜日, 6=土曜日）
   */
  getDayOfWeek(date: Date): number {
    return date.getDay();
  },

  /**
   * 日曜日かどうか判定
   */
  isSunday(date: Date): boolean {
    return date.getDay() === 0;
  },

  /**
   * 土曜日かどうか判定
   */
  isSaturday(date: Date): boolean {
    return date.getDay() === 6;
  },
};
